import React from "react";
import {Row, Col, List, Card, Button} from "antd";
import {ArticleHeader, ArticleParagraph} from "../../../components/DesignSystem/Articles/Articles";
import {Spacer} from "../../../components/DesignSystem/Spacer/Spacer";
import {DownloadOutlined} from "@ant-design/icons";

export const CsvSamplesPage = () => {

    const data = [
        {
            title: 'Population by country',
            description: 'Below is a sortable list of countries by their population 2020. There are 235 countries along with their population',
            download: 'https://apimoon-public.s3.eu-west-1.amazonaws.com/samples/Population+By+Country+2000.csv'
        },
        {
            title: 'USA House Prices',
            description: 'This dataset contains house prices in the USA, including features such as location, size, and price.',
            download: 'https://apimoon-public.s3.eu-west-1.amazonaws.com/samples/USA+Housing+Dataset.csv'
        },
        {
            title: 'Bitcoin Historical Data',
            description: 'This dataset contains historical data for Bitcoin prices from 2010-07-17 till 2025-06-15',
            download: 'https://apimoon-public.s3.eu-west-1.amazonaws.com/samples/BTC.csv',
        },
    ];

    const handleDownload = (downloadUrl) => {
        window.open(downloadUrl, '_blank');
    }

    return <Row align={"center"} style={{backgroundColor: 'white'}}>
        <Col sm={16}>
            <ArticleHeader>Sample CSV datasets for download</ArticleHeader>
            <ArticleParagraph>Example CSV datasets are a great starting point for debugging code or honing your analysis skills. Browse or download the samples below to get started.</ArticleParagraph>
            <Spacer size={"large"}/>
            <List
                grid={{ gutter: 16, column: 3 }}
                dataSource={data}
                renderItem={item => (
                    <List.Item>
                        <Card>
                            <h4>{item.title}</h4>
                            <p>{item.description}</p>
                            <Button type="primary" block icon={<DownloadOutlined />} onClick={e => handleDownload(item.download)}>Download CSV</Button>
                        </Card>
                    </List.Item>
                )}
            />
            <Spacer size={"large"}/>
        </Col>
    </Row>
}